import React from "react";
import { Github, Linkedin } from "lucide-react";
import portfolio from "../data/portfolio.json";

const { personalInfo, navLinks } = portfolio;

const Footer = () => {
  return (
    <footer className="relative border-t border-zinc-900 mt-12">
      <div className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-teal-300/30 to-transparent" />
      <div className="max-w-7xl mx-auto px-6 py-14">
        <div className="grid md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <a href="#" className="font-display text-3xl font-bold text-white">
              robertandros<span className="text-teal-300">.</span>dev
            </a>
            <p className="mt-4 text-zinc-400 max-w-md leading-relaxed">
              Software engineer based in Iași, Romania. I build web apps.
            </p>
            <div className="mt-6 flex items-center gap-2">
              {[
                { Icon: Github, href: "https://github.com/robertandros" },
                { Icon: Linkedin, href: "https://www.linkedin.com/in/robert-andros-a91266132/" },
              ].map(({ Icon, href }, i) => (
                <a
                  key={i}
                  href={href}
                  target="_blank"
                  rel="noreferrer"
                  className="w-10 h-10 rounded-xl border border-zinc-800 hover:border-teal-300/40 flex items-center justify-center text-zinc-400 hover:text-teal-300 hover:bg-white/5 transition-all"
                >
                  <Icon className="w-4 h-4" />
                </a>
              ))}
            </div>
          </div>

          <div className="md:col-span-3">
            <div className="text-xs font-mono text-zinc-500 uppercase tracking-wider mb-4">
              Navigate
            </div>
            <ul className="space-y-2">
              {navLinks.map((l) => (
                <li key={l.name}>
                  <a
                    href={l.href}
                    onClick={(e) => {
                      e.preventDefault();
                      document
                        .querySelector(l.href)
                        ?.scrollIntoView({ behavior: "smooth" });
                    }}
                    className="text-zinc-300 hover:text-teal-300 transition-colors"
                  >
                    {l.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <div className="text-xs font-mono text-zinc-500 uppercase tracking-wider mb-4">
              Get in touch
            </div>
            <a
              href={`mailto:${personalInfo.email}`}
              className="text-white hover:text-teal-300 transition-colors text-lg"
            >
              {personalInfo.email}
            </a>
            <p className="mt-2 text-sm text-zinc-500">{personalInfo.location}</p>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-zinc-900 text-xs text-zinc-500 font-mono">
          <div>
            © {new Date().getFullYear()} Robert Andros. All rights reserved.
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
